import { render, staticRenderFns } from "./platformSideGaoDe.vue?vue&type=template&id=ca5aadca&scoped=true&"
import script from "./platformSideGaoDe.vue?vue&type=script&lang=js&"
export * from "./platformSideGaoDe.vue?vue&type=script&lang=js&"
import style0 from "./platformSideGaoDe.vue?vue&type=style&index=0&id=ca5aadca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5aadca",
  null
  
)

export default component.exports